export const COOKIE_CONSENT_KEY = "hba_cookie_consent";
export const COOKIE_CONSENT_EVENT = "hba-cookie-consent-updated";

export type CookieConsentValue = "accepted" | "declined";

export function parseCookieConsent(value: string | null | undefined): CookieConsentValue | null {
  if (value === "accepted" || value === "declined") {
    return value;
  }

  return null;
}

export function readCookieConsent(): CookieConsentValue | null {
  if (typeof document === "undefined") {
    return null;
  }

  const cookieValue = document.cookie
    .split("; ")
    .find((entry) => entry.startsWith(`${COOKIE_CONSENT_KEY}=`))
    ?.split("=")[1];

  return parseCookieConsent(cookieValue ?? null);
}

export function subscribeCookieConsent(onStoreChange: () => void) {
  if (typeof window === "undefined") {
    return () => {};
  }

  window.addEventListener(COOKIE_CONSENT_EVENT, onStoreChange);
  return () => window.removeEventListener(COOKIE_CONSENT_EVENT, onStoreChange);
}

export function persistCookieConsent(value: CookieConsentValue) {
  if (typeof document === "undefined") {
    return;
  }

  document.cookie = `${COOKIE_CONSENT_KEY}=${value}; Max-Age=31536000; Path=/; SameSite=Lax`;
  window.dispatchEvent(new CustomEvent(COOKIE_CONSENT_EVENT, { detail: value }));
}
